<template>
  <div class="relative" v-if="remainingQuantity === quantity">
    <img :src="imgSrc" alt="build your bundle banner" />
    <p class="banner-currency-title">{{ $t("OrderPage[\"Build Your Bundle\"]") }}</p>
    <p class="banner-currency-deal-names">{{anyThreePromo.bundleName}}, {{anyFivePromo.bundleName}}</p>
  </div>
  <div class="banner-bg py-4" v-else>
    <!-- fireworks animation -->
    <div class="pyro" v-if="showFirework">
      <!-- <div class="before"></div>
      <div class="after"></div> -->
    </div>
    <div class="">
      <!-- <p class="banner-title">Build your bundle</p> -->
      <!-- <p class="mt-2 banner-subtitle">{{ selectQuantity }} of {{ quantity }} selected</p> -->
      <div class="flex flex-row justify-between">
        <!-- <img src="@/assets/orderTest/order-page/promoPanel/fireworks_left.svg" v-if="showFirework" /> -->
        <div class="flex flex-col" style="height: 70px">
          <div class="flex gap-11 items-start">
            <img
              v-for="number in selectQuantity"
              :key="number"
              style="height: 70px"
              :src="boxStyle(number)"
              alt="select box"
            />
            <PromoEmptyBox :select-quantity="selectQuantity" :savedPrice="savedPrice" :anyThreePromoPrice="anyThreePromo.price" :anyFivePromoPrice="anyFivePromo.price"/>
          </div>
          <div class="flex flex-col mt-4">
            <p v-if="selectQuantity >= 3 && savedPrice > 0">{{ $t("OrderPage[\"Your unlock\"]") }}<span class="text-red-500">{{ selectQuantity === 5 ? this.anyFivePromo.bundleName : this.anyThreePromo.bundleName }}</span> {{ $t("OrderPage[\"bundle!\"]") }}</p>
            <p v-if="selectQuantity !== 5">
              {{ $t("OrderPage[\"Choose\"]") }} <span class="text-red-500">{{ selectQuantity >= 3 ? 5 - selectQuantity : 3 - selectQuantity }}</span> {{ $t("OrderPage[\"more tests to unlock\"]") }}
              <span class="text-red-500">{{ selectQuantity >= 3 ? this.anyFivePromo.bundleName : this.anyThreePromo.bundleName }}</span>
            </p>
          </div>
        </div>
        <div class="flex flex-col">
          <button 
            class="add-to-cart"
            :class="{'disabled-add-to-cart': !(selectQuantity === 3 || selectQuantity === 5)}"
            @click="handleClickAddToCart">
            <!-- {{ isUnableToFormPromo && (selectQuantity === 3 || selectQuantity === 5)}}
            Add to cart {{ selectQuantity > 3 ? ': $1000' : ': $700' }} -->
            {{ addToCartText }}
          </button>
          <p class="flex justify-between mt-3">
            {{ $t("OrderPage[\"Total:\"]") }}<span>{{ currency.symbol + totalPrice }}</span>
          </p>
          <p class="flex justify-between mt-2 text-red-500">
            {{ $t("OrderPage[\"You Saved:\"]") }}<span>{{ currency.symbol + (savedPrice > 0 && (selectQuantity === 3 || selectQuantity === 5) ? savedPrice : '-') }}</span>
          </p>
        </div>
        <!-- <img src="@/assets/orderTest/order-page/promoPanel/fireworks_right.svg" v-if="showFirework" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PromoEmptyBox from './PromoEmptyBox.vue';
export default {
  emits: ['isAddToCart'],

  components: {
    PromoEmptyBox,
  },
  props: {
    selectQuantity: {
      type: Number,
      default: 0,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    selectTestPrice: {
      type: Number,
      default: 0,
    },
    promoPrice: {
      type: Number,
      default: 0,
    },
    isUnableToFormPromo: {
      type: Boolean,
      default: false
    },
    selectTests: {
      type: Array,
      default: () => []
    },
    suggestBundle: {
      type: Object,
      default: () => {}
    },
    anyThreePromo: {
      type: Object,
      default: () => {}
    },
    anyFivePromo: {
      type: Object,
      default: () => {}
    },
    selectedVwTestPrice: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      gradientIndex: 0, 
      interval: null, 
    };
  },
  methods: {
    handleClickAddToCart() {
      this.$emit('isAddToCart');
    },
    boxStyle(index) {
      if(this.selectQuantity === 4 && this.savedPrice > 0) {
        if(index === 4) {
          return require('@/assets/orderTest/order-page/promoPanel/select_box.svg')
        } else {
          return require('@/assets/orderTest/order-page/promoPanel/gradient-box.svg') 
        }
      }
      return index <= this.gradientIndex ? require('@/assets/orderTest/order-page/promoPanel/gradient-box.svg') : require('@/assets/orderTest/order-page/promoPanel/select_box.svg')
    },
    startAnimation() {
      console.log('start animation')
      // this.showFirework = true;
      this.gradientIndex = 0; // Reset index
      if((this.selectQuantity === 3 || this.selectQuantity === 5) && this.savedPrice > 0) {
        this.startSequentialUpdate();
      }
    },
    startSequentialUpdate() {
      this.interval = setInterval(() => {
        if (this.gradientIndex <= this.selectQuantity - 1 && (this.selectQuantity === 3 || this.selectQuantity === 5)) {
          this.gradientIndex++;
        } else {
          clearInterval(this.interval);
        }
      }, 400); 
    }, 
  },

  computed: {
    ...mapState(["currency"]),
    totalPrice() {
      console.log(this.anyFivePromo)
      if(this.selectQuantity === 4 && this.savedPrice > 0) {      
        let cheapestSelectedTestPrice = Infinity
        this.selectTests.forEach(test => {
          if(test.price < cheapestSelectedTestPrice) {
            cheapestSelectedTestPrice = test.price
          }
        })
        return cheapestSelectedTestPrice + this.anyThreePromo.price
      }
      return this.selectTestPrice
    },
    remainingQuantity() {
      return this.quantity - this.selectQuantity;
    },
    imgSrc() {
      // return this.quantity === 3
      //   ? require('@/assets/orderTest/order-page/promoPanel/build_your_bundle_3for700.svg')
      //   : require('@/assets/orderTest/order-page/promoPanel/build_your_bundle_5for1000.svg');
      return require('@/assets/orderTest/order-page/promoPanel/build_your_bundle_3for7005for1000currency.png')
    },
    showFirework() {
      this.startAnimation()
      return (this.selectQuantity === 3 || this.selectQuantity === 5 ) && this.savedPrice > 0;
    },
    savedPrice() {
      if(this.selectQuantity === 3) {
        return this.selectTestPrice - this.anyThreePromo.price 
      }
      else if(this.selectQuantity === 4) {
        return this.selectTestPrice - this.anyThreePromo.price 
      }
      else if(this.selectQuantity === 5) {
        return this.selectTestPrice - this.anyFivePromo.price 
      }
      return 0
    },
    addToCartText() {
      if(this.savedPrice <= 0 && (this.selectQuantity === 3 || this.selectQuantity === 5)) {
        return this.$t("OrderPage[\"Add to Cart\"]")
      } 
      else if(this.selectQuantity <= 3) {
        return this.$t("OrderPage[\"Add to Cart:\"]") + this.currency.symbol + this.anyThreePromo.price
      }
      else if(this.selectQuantity <= 5 && this.selectQuantity > 3) {
        return this.$t("OrderPage[\"Add to Cart:\"]")+ this.currency.symbol + this.anyFivePromo.price
      }
      return ''
    }
  },
};
</script>

<style scoped>
.add-to-cart {
  display: flex;
  height: 42px;
  padding: var(--V-padding, 16px) var(--H-padding, 24px);
  justify-content: center;
  align-items: center;
  gap: var(--Spacing, 12px);
  border-radius: var(--radius, 4px);
  background: var(--color-Cyan-000, #20a7c1);
  color: white;
}

.disabled-add-to-cart {
  background: var(--color-Grey-Grey-E6, #E6E6E6);
  color: var(--color-Grey-Grey-97, #979797);
  pointer-events: none;
}

.banner-bg {
  background: linear-gradient(88.1deg, rgba(242, 229, 135, 0.5) 4.22%, rgba(255, 247, 189, 0.5) 98.58%);
  height: 170px;
  padding: 32px 24px;
}
.banner-title {
  font-size: 20px;
  font-weight: 700;
  line-height: 23.44px;
}
.banner-subtitle {
  font-weight: 400;
  line-height: 16.41px;
  color: #4a4a4a;
}

.pyro > .before,
.pyro > .after {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  box-shadow: -120px -218.66667px blue, 248px -16.66667px #00ff84, 190px 16.33333px #002bff, -113px -308.66667px #ff009d,
    -109px -287.66667px #ffb300, -50px -313.66667px #ff006e, 226px -31.66667px #ff4000, 180px -351.66667px #ff00d0,
    -12px -338.66667px #00f6ff, 220px -388.66667px #99ff00, -69px -27.66667px #ff0400, -111px -339.66667px #6200ff,
    155px -237.66667px #00ddff, -152px -380.66667px #00ffd0, -50px -37.66667px #00ffdd, -95px -175.66667px #a6ff00, -88px 10.33333px #0d00ff,
    112px -309.66667px #005eff, 69px -415.66667px #ff00a6, 168px -100.66667px #ff004c, -244px 24.33333px #ff6600, 97px -325.66667px #ff0066,
    -211px -182.66667px #00ffa2, 236px -126.66667px #b700ff, 140px -196.66667px #9000ff, 125px -175.66667px #00bbff,
    118px -381.66667px #ff002f, 144px -111.66667px #ffae00, 36px -78.66667px #f600ff, -63px -196.66667px #c800ff,
    -218px -227.66667px #d4ff00, -134px -377.66667px #ea00ff, -36px -412.66667px #ff00d4, 209px -106.66667px #00fff2,
    91px -278.66667px #000dff, -22px -191.66667px #9dff00, 139px -392.66667px #a6ff00, 56px -2.66667px #0099ff, -156px -276.66667px #ea00ff,
    -163px -233.66667px #00fffb, -238px -346.66667px #00ff73, 62px -363.66667px #0088ff, 244px -170.66667px #0062ff,
    224px -142.66667px #b300ff, 141px -208.66667px #9000ff, 211px -285.66667px #ff6600, 181px -128.66667px #1e00ff,
    90px -123.66667px #c800ff, 189px 70.33333px #00ffc8, -18px -383.66667px #00ff33, 100px -6.66667px #ff008c;
  -moz-animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
  -webkit-animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
  -o-animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
  -ms-animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
  animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
}

.pyro > .after {
  -moz-animation-delay: 1.25s, 1.25s, 1.25s;
  -webkit-animation-delay: 1.25s, 1.25s, 1.25s;
  -o-animation-delay: 1.25s, 1.25s, 1.25s;
  -ms-animation-delay: 1.25s, 1.25s, 1.25s;
  animation-delay: 1.25s, 1.25s, 1.25s;
  -moz-animation-duration: 1.25s, 1.25s, 6.25s;
  -webkit-animation-duration: 1.25s, 1.25s, 6.25s;
  -o-animation-duration: 1.25s, 1.25s, 6.25s;
  -ms-animation-duration: 1.25s, 1.25s, 6.25s;
  animation-duration: 1.25s, 1.25s, 6.25s;
}

@-webkit-keyframes bang {
  from {
    box-shadow: 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white;
  }
}
@-moz-keyframes bang {
  from {
    box-shadow: 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white;
  }
}
@-o-keyframes bang {
  from {
    box-shadow: 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white;
  }
}
@-ms-keyframes bang {
  from {
    box-shadow: 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white;
  }
}
@keyframes bang {
  from {
    box-shadow: 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white,
      0 0 white, 0 0 white, 0 0 white, 0 0 white;
  }
}
@-webkit-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0;
  }
}
@-moz-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0;
  }
}
@-o-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0;
  }
}
@-ms-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0;
  }
}
@keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0;
  }
}
@-webkit-keyframes position {
  0%,
  19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }

  20%,
  39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }

  40%,
  59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }

  60%,
  79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }

  80%,
  99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
@-moz-keyframes position {
  0%,
  19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }

  20%,
  39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }

  40%,
  59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }

  60%,
  79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }

  80%,
  99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
@-o-keyframes position {
  0%,
  19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }

  20%,
  39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }

  40%,
  59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }

  60%,
  79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }

  80%,
  99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
@-ms-keyframes position {
  0%,
  19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }

  20%,
  39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }

  40%,
  59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }

  60%,
  79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }

  80%,
  99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
@keyframes position {
  0%,
  19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }

  20%,
  39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }

  40%,
  59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }

  60%,
  79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }

  80%,
  99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}

.banner-currency-title {
  position: absolute;
  top: 30%;
  font-weight: 500;
  font-size: 20px;
  left: 5%;
}

.banner-currency-deal-names {
  position: absolute;
  top: 55%;
  font-size: 18px;
  left: 5%;
}
</style>